import React, { useState } from "react";
import { motion } from "framer-motion";

const initialForm = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  address: "",
  country: "",
  city: "",
};

export default function EmployeeProfileForm() {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState(null);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setStatus("Saving profile...");

    try {
      const response = await fetch("/saveProfile.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(form),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      if (data.status === "success") {
        setStatus("✓ Profile saved successfully.");
        setForm(initialForm);
        setTimeout(() => setStatus(null), 3000);
      } else {
        setStatus(`✗ Error: ${data.message || "Unknown server error"}`);
      }
    } catch (error) {
      setStatus(`✗ Unable to save profile: ${error.message}`);
      console.error("Profile save error:", error);
    }
  };

  return (
    <motion.div
      className="card p-3 shadow-sm border-0"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <h6 className="mb-3">Create Employee Profile</h6>
      <form onSubmit={handleSubmit}>
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">First Name</label>
            <input
              name="first_name"
              value={form.first_name}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Last Name</label>
            <input
              name="last_name"
              value={form.last_name}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Email</label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Phone</label>
            <input
              name="phone"
              value={form.phone}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Address</label>
            <input
              name="address"
              value={form.address}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">Country</label>
            <input
              name="country"
              value={form.country}
              onChange={handleChange}
              className="form-control"
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">City</label>
            <input
              name="city"
              value={form.city}
              onChange={handleChange}
              className="form-control"
            />
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mt-4">
          <button type="submit" className="btn btn-primary">
            Save Profile
          </button>
          {status && <small className="text-muted">{status}</small>}
        </div>
      </form>
    </motion.div>
  );
}




